import React from 'react';
import '../svg.css';


const Office_Furniture_Pre_Fabs = props => {
    const { fill } = props;
    return (
        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36"
            height="36px"
            width="36px"
            className='svg'
        >
            <g id="Logo"><rect id="frame" className="office_furniture_pre_fabs-1" width="36" height="36" rx="10" /></g><path className="office_furniture_pre_fabs-2" d="M11.26,14a.72.72,0,0,0,.14-.41h0l3.16-1.85-.21.63a.35.35,0,0,0,.05.33.37.37,0,0,0,.3.16h2.93a.37.37,0,0,0,.3-.16.35.35,0,0,0,.05-.33l-.72-2.15a1.1,1.1,0,0,0-2.19,0l-.16.48h0L11,13a.71.71,0,0,0-.35-.1.74.74,0,0,0-.74.73.73.73,0,0,0,.66.72l1.34,2.95H9.57a.36.36,0,0,0-.37.36v8.8a.37.37,0,1,0,.73,0v-5.5h8.8V17.27h-6Z" /><path className="office_furniture_pre_fabs-2" d="M26.43,17.27h-7v3.66H26.8v-3.3A.36.36,0,0,0,26.43,17.27Zm-2.93,2.2h-.73a.37.37,0,0,1,0-.74h.73a.37.37,0,0,1,0,.74Z" /><path className="office_furniture_pre_fabs-3" d="M19.47,23.87H26.8v-2.2H19.47Zm3.3-1.47h.73a.37.37,0,1,1,0,.73h-.73a.37.37,0,1,1,0-.73Z" /><path className="office_furniture_pre_fabs-2" d="M19.47,26.43a.36.36,0,0,0,.36.37h6.6a.36.36,0,0,0,.37-.37V24.6H19.47Zm3.3-1.1h.73a.37.37,0,1,1,0,.74h-.73a.37.37,0,0,1,0-.74Z" /></svg>
    )
};

export default Office_Furniture_Pre_Fabs;
